import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';
import search from "./utils/search";
import FormGroupWrapper from "../../Wrappers/FormGroupWrapper";
import { formGroupSelectDefaultProps, formGroupSelectPropTypes, renderFormGroupCommonPropTypes } from "../../FormGroupCommonPropTypes";
var RenderSelectSearch = function RenderSelectSearch(props) {
  var input = props.input,
    placeholderOption = props.placeholderOption,
    options = props.options,
    classConfig = props.classConfig,
    propsSearch = props.search;
  var _useState = useState(options),
    _useState2 = _slicedToArray(_useState, 2),
    filteredOptions = _useState2[0],
    setOptions = _useState2[1];
  var onSearch = useCallback(function (value) {
    if (isFunction(propsSearch)) {
      propsSearch(value, options, setOptions);
    } else {
      setOptions(search(value, options));
    }
  }, [setOptions, options, propsSearch]);
  var handleKeyUp = useCallback(function (_ref) {
    var value = _ref.target.value;
    onSearch(value);
  }, [onSearch]);
  return /*#__PURE__*/React.createElement(FormGroupWrapper, props, /*#__PURE__*/React.createElement("input", _extends({
    className: classConfig.selectField || 'form-control',
    type: "text",
    id: input.name,
    list: "".concat(input.name, "-search"),
    placeholder: placeholderOption,
    onKeyUp: handleKeyUp
  }, input)), /*#__PURE__*/React.createElement("datalist", {
    id: "".concat(input.name, "-search")
  }, filteredOptions.map(function (option) {
    return /*#__PURE__*/React.createElement("option", {
      key: option.id,
      value: option.label
    }, option.label);
  })));
};
RenderSelectSearch.propTypes = _objectSpread(_objectSpread(_objectSpread({}, renderFormGroupCommonPropTypes), formGroupSelectPropTypes), {}, {
  search: PropTypes.func
});
RenderSelectSearch.defaultProps = _objectSpread(_objectSpread({}, formGroupSelectDefaultProps), {}, {
  search: undefined
});
export default RenderSelectSearch;